module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mypage-community-form-template"
    }
  }, [_c('h2', {
    staticClass: "show-title"
  }, [_vm._v("글쓰기")]), _vm._v(" "), _c('div', {
    staticClass: "basic-form"
  }, [_c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("제목")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "입력해주세요.",
      "title": "입력해주세요."
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("요약")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excerpt),
      expression: "excerpt"
    }],
    staticClass: "input__textarea input__textarea--thin",
    attrs: {
      "rows": "2",
      "title": "결과 입력"
    },
    domProps: {
      "value": (_vm.excerpt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.excerpt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("썸네일")]), _vm._v(" "), _c('input', {
    staticClass: "inline-input__file",
    attrs: {
      "type": "file",
      "id": "thumbnail",
      "title": "thumbnail 첨부파일 선택"
    },
    on: {
      "change": function($event) {
        return _vm.imageUpload('thumbnail')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "thumbnail-img-ex",
    attrs: {
      "src": _vm.imgUrl,
      "alt": "썸네일이미지"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("내용")]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "name": "description",
      "config": _vm.fiftyplusExcerpt
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("태그")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tags),
      expression: "tags"
    }],
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "입력해주세요.",
      "title": "입력해주세요."
    },
    domProps: {
      "value": (_vm.tags)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tags = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "helper-text"
  }, [_vm._v("ex) #여행 #집 #배움")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("글 쓰기")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3816e928"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/community/CommunityForm.vue
// module id = 1355
// module chunks = 6